
import {getDefaultSearchBean} from "@wikicasa/common/model/RealEstateSearchBean";
import Place from "@wikicasa/common/model/Place";
import "../../../style/vendor/leafleft.theme.scss";
import "../../../style/components/placeSearch.scss";
import {mapState, mapActions} from "pinia";
//@ts-ignore
import {deepCopy} from "@utils/ObjectUtils";
//@ts-ignore
import {isArrNullOrEmpty} from "@utils/ArrayUtils";
import {getBasePublicValuation} from "@customTypes/PublicValuation";
import { usePlaceType }  from "@wkComposables/usePlaceType";
//@ts-ignore
import {usePlaceName} from "@wkComposables/usePlaceName";
import {SearchPlaceType} from "@customTypes/SearchPlaceTypes";
import {useSearch} from "@wkComposables/useSearch";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
import {PLACE_TYPE} from "@customTypes/PlaceType";
import {getDistrictsByZoneId, getPlace, getZones} from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
import {getPlacesAddressAutocomplete} from "@services/geographyAPI";
import {GooglePredictionType} from "@customTypes/GAutocompleteTypes";
import {SelectOptions} from "@customTypes/BaseInputTypes";
import {getPlaceFromGAutocomplete} from "@utils/GAutocompleteUtils";
import {PMCustomEvent} from "@customTypes/PlaceModalEvent/PMCustomEvent";
// @ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import {defineComponent, PropType} from "vue";
import {useSearchBeanStore} from "@store/SearchBeanStore";

enum TOP_CITIES {
  MILANO = 1,
  ROMA,
  FIRENZE,
  BOLOGNA,
  TORINO,
  GENOVA,
  NAPOLI,
  PALERMO
}

export interface TopCities {
    milano: Place,
    roma: Place,
    firenze: Place,
    torino: Place,
    genova: Place,
    napoli: Place,
    bologna: Place,
    palermo: Place
}

let publicValuationCookie: Record<string, any>;

export default defineComponent({
    name: "PlaceModal",
    components: {RadioButton, CheckboxBtn, BaseAutocomplete, BaseBtModal},
    props: {
        showPlaceModal: {
            type: Boolean
        },
        listing: {
            type: Boolean
        },
        topCityList: {
            type: Object as PropType<TopCities>
        },
        valuation: {
            type: Boolean,
        },
        place: {
            type: Object as PropType<Place>,
        },
        placedIn: {
            type: String as () => "agency" | "real-estate",
            default: "real-estate"
        },
        agencyGroup: {
            type: String,
            default: ""
        }
    },
    emits: ["hide-place-modal", "show-map", "emit-place"],
    setup(){

        const {
            currentPlaceName, //Refs
            locationLabel, zonesLabel, //Computed
            //Methods
            setCustomPlaceLabel,
            updateLocationName,
            updateZoneName,
            updateSingleDistrictName,
            updateGenericPlaceName,
            updateCityName
        } = usePlaceName()


        const {
            localityList,
            zoneList,
            searchBeanModal,
            prevSelectedLocality,
            localitySelected,
            prevZoneIDsSelected,
            zoneIDsSelected,
            zoneModifiedByUser,
            districtSelected,
            districtsObj,
            //Computed
            selectedDistrictLength,
            //Methods
            convertEnergyClassFilter,
            convertFloor,
            resetSearchBeanZonesAndLocalities,
            updateSearchModal,
            updateSearchModalAndPlace,
            fixSearchBean,
            initZonesAndLocalities,
            areAllDistrictsSelected,
            isZoneOrLocalitySelected,
            areZonesAndLocalitiesEmpty,
            areZonesAndLocalitiesFilled,
            getSingleSelectedDistrict,
            getZoneById,
            resetZoneAndLocalities,
            isZoneSelected,
            isLocationSelected,
            isDistrictSelected,
            insertDistrictByZoneId,
            onPlaceLIClick,
            onDistrictClick,
        } = usePlaceType()

        const { search } = useSearch()

        return {
            //Refs
            currentPlaceName,
            //Computed
            locationLabel, zonesLabel,
            //Methods
            setCustomPlaceLabel,
            updateLocationName,
            updateZoneName,
            updateSingleDistrictName,
            updateGenericPlaceName,
            updateCityName,
            //usePlaceType
            localityList,
            zoneList,
            searchBeanModal,
            prevSelectedLocality,
            localitySelected,
            prevZoneIDsSelected,
            zoneIDsSelected,
            zoneModifiedByUser,
            districtSelected,
            districtsObj,
            //Computed
            selectedDistrictLength,
            //Methods
            convertEnergyClassFilter,
            convertFloor,
            resetSearchBeanZonesAndLocalities,
            updateSearchModal,
            updateSearchModalAndPlace,
            fixSearchBean,
            initZonesAndLocalities,
            areAllDistrictsSelected,
            isZoneOrLocalitySelected,
            areZonesAndLocalitiesEmpty,
            areZonesAndLocalitiesFilled,
            getSingleSelectedDistrict,
            getZoneById,
            resetZoneAndLocalities,
            isZoneSelected,
            isLocationSelected,
            isDistrictSelected,
            insertDistrictByZoneId,
            onPlaceLIClick,
            onDistrictClick,
            //useSearch
            search
        }
    },
    data() {
        return {
            valuationAddress: "",
            autocompleteValue: "",
            disableCb: true,
            placeTest: null as Place | null,
            mapPlace: null as Place | null,
            prevSearchBeanModal: getDefaultSearchBean(),
            showMapModal: false,
            topcityListModal: {} as TopCities,
            aroundMe: false,
            tempListUpdated: false,
            tempZoneList: [] as Place[],
            tempLocalityList: [] as Place[],
            showZoneModal: false,
            previousPlaceName: "",
            cityModal: false,
            tempPlace: null as Place | null,
            publicValuation: getBasePublicValuation(),
            openPlaceModal: false,
            pmCustomEvent: null as null | PMCustomEvent,
            isTopCitySelected: false,
            cautocompleteELSelected: false,
            modalBodyHeight: 0,
            agencyFilter: {
                name: "" as string,
                franchiseId: null as Nullable<number>
            }

        }
    },
    computed: {
        currentName(): string {
            return this.currentPlaceName;
        },
        localitiesLabel(): string {
            return window["_labels"].localities;
        },
        cdn(): string {
            return window["_cdn"]
        },
        labels(): Record<string, string> {
            return window["_labels"];
        },
        enumTopCities() {
            return TOP_CITIES;
        },
        backdrop(): HTMLElement {
            return document.getElementById("modalBackdropForNewMobileHome") as HTMLElement;
        },
        hasValuationAddress(): boolean {
            return !!this.tempPlace?.address;
        },
        address(): string {
            return this.publicValuation.realEstateValuation.address;
        },
        agencyListingTypologyURL(): string {
            return this.labels.macroTypology_url_5;
        },
        ...mapState(useSearchBeanStore, ["searchBean"])
    },
    watch: {
        showPlaceModal(cur) {
            this.openPlaceModal = cur;
        },
        cautocompleteELSelected(cur) {
            if (cur) {
                this.openCityModal();
            }
        },
        currentPlaceName(cur, prev): void {
            this.autocompleteValue = cur;
        },
    },
    created() {
        this.openPlaceModal = this.showPlaceModal;
        if (this.valuation) {
            this.openCityModal();
            return;
        }

        const isTopCitySelected = localStorage.getItem("isTopCitySelected");
        if (isTopCitySelected)
            this.isTopCitySelected = JSON.parse(isTopCitySelected) as boolean;

        /*        if (this.place?.zoneID && isArrNullOrEmpty(this.zoneIDsSelected))
            this.zoneIDsSelected.push(this.place?.zoneID)*/

        this.updateSearchModal(this.searchBean);
        this.convertEnergyClassFilter();
        this.convertFloor();

        if (this.place)
            this.placeTest = deepCopy(this.place);

        if (this.topCityList) {
            this.topcityListModal.milano = JSON.parse(this.topCityList.milano)
            this.topcityListModal.roma = JSON.parse(this.topCityList.roma)
            this.topcityListModal.palermo = JSON.parse(this.topCityList.palermo)
            this.topcityListModal.genova = JSON.parse(this.topCityList.genova)
            this.topcityListModal.napoli = JSON.parse(this.topCityList.napoli)
            this.topcityListModal.torino = JSON.parse(this.topCityList.torino)
            this.topcityListModal.firenze = JSON.parse(this.topCityList.firenze)
            this.topcityListModal.bologna = JSON.parse(this.topCityList.bologna)
        }


    },
    async mounted() {
        document.body.style.overflowY = "hidden";

        if (!this.valuation)
            this.modalBodyHeight = (document.querySelector("#place-modal .modal-body") as HTMLElement)?.offsetHeight;

        const {zoneIdList, cityId} = this.searchBeanModal;

        // if (this.placeTest?.zoneID && !this.placeTest.districtID)
        if(
            (this.searchBeanModal.zoneId || this.searchBeanModal.zoneIdList?.length === 1) &&
          (!this.searchBeanModal.districtId || !this.searchBeanModal.districtIdList?.length)
        ){
            this.zoneIDsSelected = this.searchBeanModal.zoneId ? [this.searchBeanModal.zoneId] : this.searchBeanModal.zoneIdList
            if(this.searchBeanModal.zoneId)
                this.searchBeanModal.zoneIdList = [this.searchBeanModal.zoneId]
        }
        else if (!isArrNullOrEmpty(zoneIdList) && !this.valuation && this.placeTest?.placeType !== "D"){
            this.zoneIDsSelected = zoneIdList as number[];
        }
        else if(this.placeTest?.placeType === PLACE_TYPE.DISTRICT){
            this.searchBeanModal.zoneId = null
            this.searchBeanModal.zoneIdList = [];
            this.zoneIDsSelected = []
        }

        //Just one zone
        if (cityId)
            await this.initZonesAndLocalities(getZones(cityId))

        if(this.placeTest?.placeType === PLACE_TYPE.LOCALITY && this.searchBeanModal.localityIdList)
            //@ts-ignore
            this.localitySelected = this.localityList.find(l => l.localityID === this.searchBeanModal.localityIdList[0])

        this.updatePlaceName();

        if (this.valuation)
            this.openCityModal();

        //this.updatePlaceName();
    },
    unmounted(): void  {
        document.body.style.overflowY = "auto";
    },
    methods: {
        manageCity(city: Place, updatePlaceCb: () => void, action?: () => void, initZonesAndLocalities = true): void {
            this.updateSearchModalAndPlace(city, () => {
                this.placeTest = {...city};
                this.tempPlace = {...this.placeTest} as Place;
            })
            if (initZonesAndLocalities) {
                localStorage.removeItem("isTopCitySelected");
                this.isTopCitySelected = false;
                this.initZonesAndLocalities(
                    getZones(city.cityID),
                    () => {
                        action && action();
                        this.openZoneModal();
                    },
                    () => this.updateSearchModalAndPlace(city, updatePlaceCb)
                );
            } else
                action && action();
        },
        async initSingleDistrict(zoneId: number, districtId: number){
            const districts = await getDistrictsByZoneId(zoneId);
            const singleDistrict = districts.find(d => d.districtID === districtId)
            this.$set(this.districtsObj, singleDistrict?.zoneID, [singleDistrict])
            //Adding the district to the district object
            this.insertDistrictByZoneId(zoneId, districtId)
        },
        async onInputChangeCb(query: string): Promise<any[] | void> {
            if (!query)
                return;

            const res = await getPlacesAddressAutocomplete(query, 10)
            return res.map((r: GooglePredictionType) => ({label: r.description, id: r.place_id}));
        },
        async optionSelectedCb(selectedEl: SelectOptions): Promise<void> {
            const {place, address} = await getPlaceFromGAutocomplete(`${selectedEl.id}`, selectedEl.label);
            this.tempPlace = place;
            this.valuationAddress = address;
            this.confirmPlace();
        },
        handleClick(): void {
            this.disableCb = false;

            if(this.zoneList.length > 0 || this.localitySelected)
                this.showZoneModal = true;
        },
        removeTopLocalitySelected(): void {
            localStorage.removeItem("isTopCitySelected");
            this.isTopCitySelected = false;
            this.cautocompleteELSelected = false;
        },
        handleChange(curVal: string): void {
            if (!curVal) {
                this.clearCautocomplete();
            } else
                this.currentPlaceName = curVal;
        },
        closeModal() {
            this.pmCustomEvent = {type: "hide-place-modal"};
            this.openPlaceModal = false;
        },
        clearCautocomplete() {
            this.setCustomPlaceLabel("");
            this.zoneList = [];
            this.localityList = [];
            this.placeTest = null;
            this.cityModal = false;
            this.showZoneModal = false;
        },
        //Whenever we select a city from the result of the autocomplete this function will be called
        managePlace(obj: Place, action: (() => void) | undefined = undefined, initZonesAndLocalities = true): void {
            this.disableCb = true;
            this.resetSearchBeanZonesAndLocalities();
            const updatePlaceCb = (): void => {
                this.placeTest = {...obj};
                this.confirmPlace();
            };

            if (obj.placeType == PLACE_TYPE.CITY) {
                /*this.updateSearchModalAndPlace(obj, () => {
                    this.placeTest = {...obj};
                    this.tempPlace = {...this.placeTest} as Place;
                })
                if (initZonesAndLocalities) {
                    localStorage.removeItem("isTopCitySelected");
                    this.isTopCitySelected = false;
                    this.initZonesAndLocalities(
                        getZones(obj.cityID),
                        () => {
                            action && action();
                            this.openZoneModal();
                        },
                        () => this.updateSearchModalAndPlace(obj, updatePlaceCb)
                    );
                } else
                    action && action();*/
                this.manageCity(obj, updatePlaceCb, action, initZonesAndLocalities)
            } else if (obj.placeType == PLACE_TYPE.DISTRICT) {
                this.initSingleDistrict(obj.zoneID, obj.districtID).then(() => {
                    this.updateSearchModalAndPlace(obj, updatePlaceCb)
                })
            }
            else
                //e.g. if the selected option is a province...
                this.updateSearchModalAndPlace(obj, updatePlaceCb);

            this.updatePlaceName();
        },
        updatePlaceName() {
            /* LOCALITY */
            if (this.localitySelected || (this.placeTest?.localityID && !this.zoneIDsSelected.length)) {
                this.updateLocationName(this.localitySelected ?? this.placeTest);
                return;
            }
            /* DRAWN AREA MAP */
            // eslint-disable-next-line max-len
            if ((this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I")
            || (!this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I")) {
                this.currentPlaceName = this.labels.mapAreaDrawn;
            }
            /* VACATION PLACE LIKE CINQUE TERRE */
            else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
                this.currentPlaceName = this.searchBean?.cityDisplayName;
            } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
                this.updateGenericPlaceName(this.placeTest);
            } else {

                //Zones and district greater than one
                if(this.zoneIDsSelected.length >= 0 || this.searchBeanModal.districtIdList?.length >= 0){
                    if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(this.placeTest?.placeType || "") &&
                    !this.zoneIDsSelected.length //This check is done to exclude the following scenario: Olbia -> locality, close and open modal, select zones
                    )
                        this.updateGenericPlaceName(this.placeTest);
                    else if(!this.searchBeanModal.districtIdList?.length && !this.zoneIDsSelected.length)
                        this.updateCityName(this.placeTest);
                    else if((!this.zoneIDsSelected.length && this.searchBeanModal.districtIdList?.length === 1) /*|| this.placeTest?.placeType === PLACE_TYPE.DISTRICT*/)
                        this.updateSingleDistrictName(this.getSingleSelectedDistrict());
                    else if(this.zoneIDsSelected.length === 1 && !this.searchBeanModal.districtIdList?.length)
                        this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);
                    else
                        this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + this.searchBeanModal.districtIdList?.length);
                }
            }
        },
        setTopPlace(city: TOP_CITIES) {
            localStorage.setItem("isTopCitySelected", "true")
            //Each time we select a top city, we will start from a clean state
            this.resetSearchBeanZonesAndLocalities();
            //Creating a callback function to update the cities
            const updateCityCb = (city: Place) => {
                return (): void => {
                    this.tempPlace = {...this.placeTest} as Place;
                    this.placeTest = {...city};
                }
            };

            switch (city) {
                case TOP_CITIES.MILANO:
                    const {milano} = this.topcityListModal;
                    this.updateSearchModalAndPlace(milano, updateCityCb(milano));
                    break;
                case TOP_CITIES.ROMA:
                    const {roma} = this.topcityListModal;
                    this.updateSearchModalAndPlace(roma, updateCityCb(roma));
                    break;
                case TOP_CITIES.FIRENZE:
                    const {firenze} = this.topcityListModal;
                    this.updateSearchModalAndPlace(firenze, updateCityCb(firenze))
                    break;
                case TOP_CITIES.TORINO:
                    const {torino} = this.topcityListModal;
                    this.updateSearchModalAndPlace(torino, updateCityCb(torino))
                    break;
                case TOP_CITIES.GENOVA:
                    const {genova} = this.topcityListModal;
                    this.updateSearchModalAndPlace(genova, updateCityCb(genova))
                    break;
                case TOP_CITIES.NAPOLI:
                    const {napoli} = this.topcityListModal;
                    this.updateSearchModalAndPlace(napoli, updateCityCb(napoli))
                    break;
                case TOP_CITIES.PALERMO:
                    const {palermo} = this.topcityListModal;
                    this.updateSearchModalAndPlace(palermo, updateCityCb(palermo))
                    break;
                case TOP_CITIES.BOLOGNA:
                    const {bologna} = this.topcityListModal;
                    this.updateSearchModalAndPlace(bologna, updateCityCb(bologna))
                    break;
            }

            this.updateSearchBean(this.searchBeanModal);

            if (this.listing && this.placedIn === "agency") {
                this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null)
                //: this.search(this.searchBeanModal);
                return;
            }

            this.placeTest && this.managePlace(
                this.placeTest, () => {
                    //Updating prev zones and localities the zone and localities
                    this.tempZoneList = [...this.zoneList];
                    this.tempLocalityList = [...this.localityList];
                    //Updating previous place name
                    this.previousPlaceName = this.currentPlaceName;
                    //Updating the search bean
                    this.prevSearchBeanModal = deepCopy(this.searchBeanModal);
                    //Updating the tempPlaceModal
                    this.tempPlace = deepCopy(this.placeTest);
                },
                true
            );
        },
        close(): void {
            if (this.listing) {
                this.placedIn === "agency"
                    ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null)
                    : this.search(this.searchBeanModal)
            } else
                this.emitPlace();
        },
        openCityModal(): void {
            this.cityModal = true;
        },
        async getPlaceFn(query: string): Promise<Place[] | void> {
            if (!query)
                return;

            this.autocompleteValue = query;
            this.resetZoneAndLocalities();
            const res = await getPlace(query, "C,P,Z,L,I,R,A,D")
            //@ts-ignore
            return res.map((place, index) => ({id: index, label: place.displayName, payload: place}));
        },
        onWholeMunicipalityClick(resetLocalityId = true, updateCityName = true) {
            this.zoneIDsSelected = [];
            this.localitySelected = undefined;
            //In order to update correctly the locality id, which will be null in case we check the option "whole municipality", we set the locality id to a valid falsy value!
            if (this.placeTest && resetLocalityId)
                this.placeTest.localityID = 0;
            //If there is no info about the zones in and the localities in the searchBean, then we will try to search by the city!
            this.searchBeanModal.zoneId = null;
            this.searchBeanModal.zoneIdList = [];
            this.searchBeanModal.zoneURL = null;
            this.searchBeanModal.localityIdList = [];
            this.searchBeanModal.districtId = null;
            this.searchBeanModal.districtIdList = []
            this.districtSelected = {}
            //When we select the whole municipality, we will update the current field with the name of the city!
            updateCityName && this.updateCityName(this.placeTest)
            //Updating the place modal with a valid display name
            this.placeTest = {...this.placeTest, displayName: this.currentPlaceName} as Place;
        },
        confirmPlace() {
            if (this.valuation) {
                this.publicValuation.realEstateValuation.address = this.tempPlace?.address || "";
                this.placeTest = {...this.tempPlace} as Place;
                this.tempPlace = null;
                this.emitPlace();
            } else {
                /* Handling whole municipality scenario */
                if(!this.isZoneOrLocalitySelected() && !(Object.keys(this.districtSelected).length > 0) && this.placeTest?.placeType === PLACE_TYPE.CITY){
                    this.onWholeMunicipalityClick(false, false)
                }

                this.fixSearchBean(
                    () => {
                        this.placeTest = this.zoneList.find((plc: Place) => plc.zoneID == this.searchBeanModal.zoneId) || this.placeTest;
                        return this.placeTest?.zoneURL;
                    },
                    () => {
                        this.placeTest = this.localitySelected ? {...this.localitySelected} as Place : this.placeTest;
                        return this.placeTest?.zoneURL;
                    }, () => {
                        return this.placeTest?.zoneURL;
                    }
                );
                this.updatePlaceName();
                delete this.searchBeanModal.polygonFromMap;
                delete this.searchBeanModal.polygonForDB;

                this.updateSearchBean({
                    polygonFromMap: this.searchBeanModal.polygonFromMap,
                    polygonForDB: this.searchBeanModal.polygonForDB,
                    placeId: this.searchBeanModal.placeId,
                    zoneIdList: this.searchBeanModal.zoneIdList!,
                    localityIdList: this.searchBeanModal.localityIdList!,
                    zoneId: this.searchBeanModal.zoneId,
                    cityId: this.searchBeanModal.cityId,
                    cityDisplayName: this.searchBeanModal.cityDisplayName,
                    cityURL: this.searchBeanModal.cityURL,
                    zoneURL: this.searchBeanModal.zoneURL,
                    districtURL: this.searchBeanModal.districtURL,
                    districtId: this.searchBeanModal.districtId,
                    districtIdList: this.searchBeanModal.districtIdList
                })

                this.prevSearchBeanModal = deepCopy(this.searchBeanModal)!;
                this.prevZoneIDsSelected = [...this.zoneIDsSelected];
                this.prevSelectedLocality = this.localitySelected ? {...this.localitySelected} : undefined;

                //Since the user has accepted its search, we can update the temp buffers!
                this.tempLocalityList = [...this.localityList];
                this.tempZoneList = [...this.zoneList];
                this.previousPlaceName = this.currentPlaceName;
                this.tempPlace = this.placeTest ? {...this.placeTest} : null;

                if (this.listing) {
                    this.placedIn === "agency"
                        ? this.search(true, this.agencyListingTypologyURL, false, this.agencyFilter.name || this.agencyFilter.franchiseId ? this.agencyFilter : null)
                        : this.search(this.listing);
                }
                else
                    this.emitPlace()
            }


        },
        browserSupportGeolocation(): boolean {
            return !!window.navigator.geolocation;
        },
        openMapDraw(): void {
            this.showMap();
        },
        openMapAroundMe(): void {
            this.aroundMe = true;
            this.openMapDraw();
        },
        hideMapModal() {
            this.showMapModal = false

        },
        openZoneModal(): void {
            //Now that we have extracted from the zoneList the localities, we have to check the length of both the lists!
            if (this.valuation) return;
            this.cityModal = true;

            this.showZoneModal = !!(this.zoneList.length + this.localityList.length);
        },
        closeZoneModal(): void {
            this.showZoneModal = false
        },
        hidePlaceModal() {
            //Whenever we click the "go back" button, we will retrieve the previous search results!
            this.zoneList = [...this.tempZoneList];
            this.localityList = [...this.tempLocalityList];

            if(!this.pmCustomEvent)
                this.$emit("hide-place-modal")
            else
                this.$emit(this.pmCustomEvent.type, this.pmCustomEvent.payload);
        },
        showMap() {
            this.$emit("show-map", {
                aroundMe: this.aroundMe,
                searchBean: this.searchBeanModal,
            });
        },
        emitPlace() {
            this.updateSearchBean({
                zoneIdList: this.searchBeanModal.zoneIdList,
            })
            if((this.searchBeanModal.districtIdList?.length === 1 && !this.searchBeanModal.zoneIdList?.length) ){
                if(this.placeTest)
                    this.placeTest.districtName = this.getSingleSelectedDistrict()?.districtName ?? "";
            }

            this.pmCustomEvent = {
                type: "emit-place",
                payload: {
                    place: this.placeTest,
                    aroundMe: false,
                    radius: 0,
                    searchBean: this.searchBean,
                    polygon: "",
                    polygonFromMap: "",
                    polygonForDB: "",
                } as SearchPlaceType
            }

            this.openPlaceModal = false;
        },
        ...mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
    },
})
